module.exports = __webpack_public_path__ + "img/olives_bg_detail.13e5f10.png";